import FavoriteType from "../enums/favoriteType";
import SpecProductType from "../models/specProductType";
import PlanProductType from "../models/planProductType";
import CommunityProductType from "../models/communityProductType";

const housingProductConstructor = new Map();

housingProductConstructor.set(FavoriteType.Spec.toString(), SpecProductType);
housingProductConstructor.set(FavoriteType.Plan.toString(), PlanProductType);
housingProductConstructor.set(FavoriteType.Community.toString(), CommunityProductType)

/**
 * Returns the class constructor with the listing information according to the type.
 *
 * @param type - The type of listing (Spec, plan, community).
 * @param listingInformation - The listing (Spec, plan, community) information.
 */

export default (type, listingInformation) => {
    const generator = housingProductConstructor.get(type);
  
    if (!generator) {
      return null;
    }
  
    return new generator.prototype.constructor(listingInformation);
  };
  